howspace.components.userFilterPicker = (() => {
    'use strict';

    const getFilter = userFilterPicker => {
        const dataPayload = real.form.getDataPayload(userFilterPicker);

        const filters = dataPayload.filters ?? [];
        dataPayload.users?.forEach(userId => {
            filters.push(`user:${userId}`);
        });

        return filters;
    }

    const updateFilter = e => {
        const userFilterPicker = $(e.currentTarget).closest('.howspace-user-filter-picker');

        const filters = getFilter(userFilterPicker);
        const previousFilters = userFilterPicker.data('previous-filters') || [];
        if (JSON.stringify(previousFilters) === JSON.stringify(filters)) {
            return;
        }
        userFilterPicker.data('previous-filters', filters);

        const input = $(e.currentTarget);
        if (input.is('input[type="radio"]') && input.prop('checked')) {
            const collapse = input.closest('.collapse');
            if (input.val().endsWith('000')) {
                howspace.animate(collapse.find('.date-wrapper:hidden'), 'slideDown');
            } else {
                howspace.animate(collapse.find('.date-wrapper:visible'), 'slideUp');
            }
        }

        howspace.dispatchEvent(userFilterPicker, howspace.components.userFilterPicker.FILTER_CHANGED, filters);
    }

    const updateDateFilter = e => {
        // The howspace.components.datePicker.DATE_CHANGED event is fired from .howspace-date-picker,
        // so we need to use e.target to indicate the correct date picker element.
        // if we used e.currentTarget, it would refer to .howspace-user-filter-picker
        const datePicker = $(e.target);
        const collapse = datePicker.closest('.collapse');

        collapse.find('input[data-name="filters[]"]').each(function() {
            const input = $(this);
            input.val(input.val().replace(/^(.*:)\d+$/, `$1${e.detail}`));
        });

        updateFilter(e);
    }

    // The picker is locked while the lister it feeds reloads, and unlocked once the new items are in. Only a
    // picker attached to a lister does this: a picker without one, such as the custom export modal's, has
    // nothing that would unlock it again and would stay disabled after its first change.
    const attachToParentLister = elem => {
        elem.on(howspace.components.userFilterPicker.FILTER_CHANGED, e => {
            const userFilterPicker = $(e.currentTarget);
            const lister = userFilterPicker.closest('.howspace-lister');

            howspace.form.disable(userFilterPicker);

            lister.on(howspace.components.lister.LIST_ITEMS_RENDERED, e => {
                howspace.form.enable(userFilterPicker);
            });

            howspace.components.lister.unselectAllItems(lister);
            howspace.components.lister.reload(lister);
        });
    }

    return {
        FILTER_CHANGED: 'howspace-user-filter-picker-filter-changed',
        init: elem => {
            elem.findIncludingSelf('.howspace-user-filter-picker:not(.howspace-user-filter-picker-initialized)').each(function () {
                const userFilterPicker = $(this);
                userFilterPicker.addClass('howspace-user-filter-picker-initialized');

                userFilterPicker.on(howspace.components.collapse.COLLAPSED, updateFilter);
                userFilterPicker.on(howspace.components.collapse.EXPANDED, updateFilter);
                userFilterPicker.on(howspace.components.userPicker.USER_ADDED, updateFilter);
                userFilterPicker.on(howspace.components.userPicker.USER_REMOVED, updateFilter);
                userFilterPicker.on(howspace.components.datePicker.DATE_CHANGED, updateDateFilter);
                userFilterPicker.on('change', 'input[name="filters[]"]', updateFilter);
                userFilterPicker.on('change', 'input[data-name="filters[]"]', updateFilter);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-user-filter-picker.howspace-user-filter-picker-initialized').each(function () {
                const userFilterPicker = $(this);
                userFilterPicker.removeClass('howspace-user-filter-picker-initialized');

                userFilterPicker.off(howspace.components.collapse.COLLAPSED, updateFilter);
                userFilterPicker.off(howspace.components.collapse.EXPANDED, updateFilter);
                userFilterPicker.off(howspace.components.userPicker.USER_ADDED, updateFilter);
                userFilterPicker.off(howspace.components.userPicker.USER_REMOVED, updateFilter);
                userFilterPicker.off(howspace.components.datePicker.DATE_CHANGED, '.howspace-date-picker',  updateDateFilter);
                userFilterPicker.off('change', 'input[name="filters[]"]', updateFilter);
                userFilterPicker.off('change', 'input[data-name="filters[]"]', updateFilter);
                userFilterPicker.off('change', 'input.filter-checkbox');
            });
        },
        attachToParentLister: attachToParentLister,
        getFilter: getFilter
    }
})();
